module.exports = __webpack_public_path__ + "img/wix.853156a.svg";